// React imports
// None

// Third-party imports
// None

// Styles
import styles from './DiscountsIsEmpty.module.scss';

const DiscountsIsEmpty = ({ title, text }: { text: string; title: string }) => {
    return (
        <div className={styles.containerEmpty}>
            <img
                className={styles.imageEmpty}
                src="/images/memberships/clients-notfound.svg"
                alt="No discounts"
            />
            <h2 className={styles.titleEmpty}>{title}</h2>
            <div className={styles.descriptionEmptyContainer}>
                <p className={styles.descriptionEmpty}>{text}</p>
            </div>
        </div>
    );
};

export default DiscountsIsEmpty;
